import React, { useEffect, useState } from 'react';
import '../../main-css/navigation.css';
import LoginPopUp from './LoginPopUp.js';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_PROD_URL;

const AniListLoginButton = () => {
    const [username, setUsername] = useState(null);
    const [aniUser, setAniUser] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    
    useEffect(() => {
      fetchUserInfo();
    }, []);
    
     // Handle button click
     const handleButtonClick = (e) => {
      e.preventDefault();

      if (username) {
        if (!aniUser) {
            // If user is signed in but AniList is not linked, redirect to AniList linking
            window.location.href = `${BACKEND_URL}/auth/anilist`;
        } else {
            console.log("AniList is already connected.");
        }
      } else {
          // If not signed in, open login modal
          setModalOpen(true);
      }
    };
    
    const fetchUserInfo = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/valid/profile`, {
          method: 'GET',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json'
          }
        });

        const responseAni = await fetch(`${BACKEND_URL}/auth/anilist/get-user-info`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.user) {
            setUsername(data.user);
          }
        }

        if (responseAni.ok) {
          const dataAni = await responseAni.json();
          if (dataAni.username) {
            setAniUser(dataAni.username);
          }
        }

      } catch (err) {
        console.error('Error fetching user info:', err);
      }
    };
  
  
    return (
      <div>
            <a onClick={handleButtonClick} className="anilist-login-button">
                {username ? 'AniList Connected' : 'AniList Login'}
            </a>

            {isModalOpen && <LoginPopUp onClose={() => setModalOpen(false)} />}
      </div>
    );
};

export default AniListLoginButton;